import React, { useContext, useState, useEffect } from 'react';
import { FarzaaContext } from '../../context/FarzaaContext';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { AuthContext } from '../authentication/AuthContext'; 
// import { StoreContext } from '../../context/StoreContext';


import axios from 'axios';

const apiUrl = import.meta.env.VITE_API_URL;

const RelatedProductSection = ({ brandId, subcategoryId }) => {
    const { t, i18n } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    // const { token } = useContext(AuthContext); // Get token from AuthContext
    //     const { addToWishlist, addToCart } = useContext(StoreContext);
    

    const [error, setError] = useState(null);

//     const handleAddToCart = (product) => { 
//         if (!token) {
//             // If user is not logged in, redirect to login
//             navigate('/login');
//         } else {
//             // If user is logged in, add to cart
//             addToCart(product);
//         }
//     };
//     const handleAddToWishlist = (product) => {
//       if (!token) {
//           // If user is not logged in, redirect to login
//           navigate('/login');
//       } else {
//           // If user is logged in, add to wishlist
//           addToWishlist(product);
//       }
//   };


    useEffect(() => {
        const fetchRelatedProducts = async () => {
          try {
            // const response = await axios.get(`${apiUrl}/api/products/search?brand_id=${brandId}`);
            const response = await axios.get(
                `${apiUrl}/api/products/search?brand_id=${brandId}&subcategory_id=${subcategoryId}`
              );
            const relatedProducts = response.data.data.slice(0, 4); // Access `data` array
            setProducts(relatedProducts);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching related products:", error);
            setError('Failed to load related products.');
            setLoading(false);
          }
        };
      
        if (brandId) {
          fetchRelatedProducts();
        }
      }, [brandId]);


    if (loading) return <div>Loading related products...</div>;
    if (error) return <div>{error}</div>;

    return (
        <section className="related-product-section">
            <div className="container">
                <h2 className="related-product__title">{t('Related Products')}</h2>
                <div className="row gy-sm-4 g-3 justify-content-center">
                {products.length > 0 ? (
                          products.map((product) => (
                            <div className="col-lg-3 col-md-4 col-6 order-lg-1 order-2" key={product.id}>
                                <div className="fz-5-single-product">
                                    
                                    <div className="fz-5-single-product-img">
                         <Link className="fz-5-single-product-img" to={`/product/${product.slug_en}`}>
                                        
                                        <img src={`${apiUrl}/uploads/${product.image}`} alt={product.title_en} />
                                        </Link>
                                        {/* <div className="fz-5-single-product-actions">
                                            <a 
                                                role="button" 
                                                className="fz-add-to-wishlist"
                                                onClick={() => handleAddToWishlist(product)}
                                            >
                                                <i className="fa-regular fa-heart"></i>
                                            </a>
                                            <a
                                                role="button"
                                                className="fz-add-to-cart-btn" 
                                                onClick={() => handleAddToCart(product)}
                                            >
                                                <i className="fa-regular fa-cart-shopping"></i>
                                            </a>
                                        </div> */}
                                    </div>
                                    <div className="fz-5-single-product-txt">
                                        <h3 className="fz-5-single-product-title">
                                            <Link to={`/product/${product.slug_en}`}>
                                                {i18n.language === 'en' ? product.title_en : product.title_ar}
                                            </Link>
                                        </h3>
                                        <Link to={`/product/${product.slug_en}`}>

                                        <p className="fz-5-single-product-price">{t("SR")} {product.selling_price}</p>
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>{t('No related products found.')}</p>
                    )}
                </div>
            </div>
        </section>
    );
}

export default RelatedProductSection;